<template>
    <div v-if="hasValidElementToShow"
         class="root-media-container"
         :class="{'blur-enable': blurBg}">
        <div class="media-container media-video-container"
             :class="{'media-video-container-full-height': isFullHeightContent}">

            <div v-if="media.MediaType == 'LiveWebSource' && !editMode"
                class="embed-container">

                <iframe :src="iFrameSrc" allow="camera;microphone;fullscreen" allowfullscreen>

                </iframe>
            </div>

            <div v-else-if="media && media.MediaType == 'MuxLive' && !editMode"
                 class="hls-container">
                <mux-player :playback-id="media.Uri"
                            :metadata-video-id="muxVideoMetadata"
                            :metadata-viewer-user-id="muxUserId"
                            :metadata-video-title="entityName"
                            default-stream-type="live"
                            :placeholder="media.ThumbnailUri"
                            ref="muxVideoPlayer"
                            autoplay
                            @canplay="onCanPlay"
                            @error="onError"
                            @playing="onMuxEvent"
                            @pause="onMuxEvent"
                            @ended="onMuxEvent">
                </mux-player>
            </div>
            <div v-else-if="media && media.MediaType == 'MuxAsset' && !editMode"
                 class="hls-container">
                <mux-player :playback-id="media.Uri"
                            :metadata-video-id="muxVideoMetadata"
                            :metadata-viewer-user-id="muxUserId"
                            :metadata-video-title="entityName"
                            :placeholder="media.ThumbnailUri"
                            ref="muxVideoPlayer"
                            @playing="onMuxEvent"
                            @pause="onMuxEvent"
                            @ended="onMuxEvent">
                </mux-player>
            </div>            
            <div v-else
                class="cover-container"
                @click="onMediaPhotoClick">
                <img-g v-if="media.ThumbnailUri"
                    :src="media.ThumbnailUri" />
                <img-g v-else :src="fallbackPhoto" />

                <slot>

                </slot>
            </div>
        </div>

        <!--<div>
            <strong>Watch Time: {{totalWatchTimeSeconds}}</strong>
            <div v-for="ev in __debugEvents">
                {{ev}}
            </div>
        </div>-->
    </div>
</template>
<script>
import { AppState } from './appstate';
import Common from './common'
import Token from './authentication/token'
import "@mux/mux-player";
import loadingContainer from './loading.container.vue';

export default {
  components: { loadingContainer },
    props: [
        'entityCode',
        'entityTypeCode',
        'entityName',
        'media',
        'fallbackPhoto',
        'forceShow',
        'editMode',
        "blurBg"
    ],

    mixins: [
        Token,
        Common,
        //ElementMixin
    ],   

    data() {
        return {
            wasWarnedAboutAutoplayBlock: false,
            lastPlayAt: null,
            totalWatchTimeSeconds: 0,
            statusReportInterval: null,
            loginInstanceCode: null,
            __debugEvents: [],
        }
    },

    watch: {
        media(newMedia, oldMedia) {
            if(!oldMedia) {
                return;
            }  

            if(oldMedia.MediaType != 'MuxLive' && oldMedia.MediaType != "MuxAsset") {
                return;
            }

            this.onMuxEvent({type: 'mediachange'});

            if(newMedia && !oldMedia || (oldMedia.Uri != newMedia.Uri)) {
                this.totalWatchTimeSeconds = 0;
            }
        },
    },

    computed: {
        isFullHeightContent() {
            return this.iFrameSrc
                && this.iFrameSrc.startsWith('/zoom.html');
        },

        hasValidElementToShow() {
            if(this.forceShow) {
                return true;
            }
            
            if(!this.media && !this.fallbackPhoto) {
                return false;
            }

            if(this.media 
                && !this.media.MediaType 
                && !this.media.ThumbnailUri 
                && !this.fallbackPhoto) {
                return false;
            }

            if(this.media
                && this.media.MediaType
                && !this.media.Uri
                && !this.media.ThumbnailUri
                && !this.fallbackPhoto)
            {
                return false;                
            }

            return true;
        },

        muxVideoMetadata() {
            return `${AppState.attendee.Show.Code}_${this.entityTypeCode}_${this.entityCode}`;
        },

        muxUserId() {
            return `${AppState.attendee.Show.Code}_${AppState.attendee.Code}`;
        },

        iFrameSrc() {

            if(this.media 
                && this.media.MediaType == 'LiveWebSource') {

                let link = this.media.Uri;

                if(link.indexOf('{{showCode}}') != -1) {
                    link = link.replace('{{showCode}}', AppState.attendee.Show.Code);
                } 

                if(link.indexOf('{{attendeeCode}}') != -1) {
                    link = link.replace('{{attendeeCode}}', AppState.attendee.Code);
                }

                if(link.indexOf('{{entityTypeCode}}') != -1) {
                    link = link.replace('{{entityTypeCode}}', this.entityTypeCode);
                }

                if(link.indexOf('{{entityCode}}') != -1) {
                    link = link.replace('{{entityCode}}', this.entityCode);
                }

                return link;
            }

        },        
    },

    methods: {
        async onCanPlay() {
            console.log('onCanPlay - mux player');
            // const isMobile =
            //     (navigator.userAgentData && navigator.userAgentData.mobile) ||
            //     /Android|iPhone|iPad|iPod|Mobi/i.test(navigator.userAgent);

            // if (isMobile) {
            //     console.log('📱 Mobile detected — skipping autoplay logic');
            //     // if you still want to show a “Join” button or similar,
            //     // you can set a flag here instead of returning early.
            //     return;
            // }

            let v = this.$refs.muxVideoPlayer;

            try {
                console.log('asking to play...');
                await v.play();
                console.log('play...');
            } catch(ex) {
                console.error("Autoplay failed.", ex);
                if(this.wasWarnedAboutAutoplayBlock) {
                    return;
                }

                this.wasWarnedAboutAutoplayBlock = true;

                let promise = new Promise(r => {
                    this.$awn.confirm(
                        "Your browser has blocked auto-play of the conference audio. Click 'Join' to listen.",
                        () => {
                            r('End');
                        },
                        false,
                        {
                            labels: {
                                confirm: "Join",
                            }
                        }
                    )
                });

                await promise;

                await v.play();
            }
        },

        onError() {

        },

        onMediaPhotoClick() {
            this.$emit('cover-click');
        },

        async onMuxEvent(e) {
            console.log("onMuxEvent!", this.$refs.muxVideoPlayer, e);
            if(!this.lastPlayAt && (e.type == 'playing' || e.type == "playing-sr")) {
                this.lastPlayAt = new Date();
            }

            if(this.lastPlayAt) {
                let playTime = this.lastPlayAt;
                let currentTime = new Date();
                
                let diff = currentTime - playTime;
                diff = diff / (1000.0);
                this.totalWatchTimeSeconds += diff; 
                
                this.lastPlayAt = currentTime;
            }

            if(e.type == 'pause-sr') {
                return;
            }

            if(e.type == 'pause' || e.type == 'player-destroy') {
                this.lastPlayAt = null;
            }

            const playbackKey = 
                this.media && this.media.Uri
                && this.media.MediaType && this.media.MediaType.indexOf("Mux") != -1
                ? this.media.Uri
                : null;

            console.warn("Submitting status update...");            

            const routeUrl = `${process.env.VUE_APP_API_URL}/api/webinar/${AppState.attendee.Show.Code}/${this.entityCode}/viewer/watch`;

            const ev = {
                UserCode: AppState.attendee.Code,
                EventType: e.type,
                ReportDateTimeUtc: new Date(),
                PlaybackKey: playbackKey,
                InstanceCode: `${this.getDeviceId()}_${this.loginInstanceCode}`,
                TotalWatchTimeSeconds: this.totalWatchTimeSeconds
            };

            this.__debugEvents.splice(0, 0, ev);

            await fetch(routeUrl, {
                mode: 'cors',
                method: 'post',
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify(ev)
            });

        },       
        
        async onStatusReport() {
            if(this.showLoginForm) {
                return;
            }

            if(!this.$refs.muxVideoPlayer) {
                return;
            }

            let state = !this.$refs.muxVideoPlayer.paused ? "playing-sr" : 'pause-sr'; 
            
            this.onMuxEvent({type: state});
        },

    },

    beforeUnmount() {
        try {
            this.$refs.muxVideoPlayer.pause();
        } catch {

        }


        if(this.statusReportInterval) {
            clearInterval(this.statusReportInterval);
            this.statusReportInterval = null;
        }

        //console.warn(this.media, this.$refs.muxVideoPlayer, "!!!!");
        if(!this.media) {
            return;
        }

        if(this.media.MediaType != 'MuxLive' && this.media.MediaType != "MuxAsset") {
            return;
        }

        this.onMuxEvent({type: 'player-destroy'});
    },

    mounted() {
        console.log(this.media);
        this.loginInstanceCode = this.createUniqueCode();
        if(!this.statusReportInterval) {
            this.statusReportInterval = setInterval(this.onStatusReport, 60000);
        }
    }

}
</script>
